module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_inomemado-830ea797eadfd941b9faab07e39f29ea.jpg";